import { render, staticRenderFns } from "./CaseCreateInvoiceView.vue?vue&type=template&id=622877aa&"
import script from "./CaseCreateInvoiceView.vue?vue&type=script&lang=js&"
export * from "./CaseCreateInvoiceView.vue?vue&type=script&lang=js&"
import style0 from "./CaseCreateInvoiceView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports